import { Card, CardContent } from "@/components/ui/card";
import { StatoGuardiaBadge, ScadenzaBadge } from "@/components/StatoBadge";
import { fmtDate } from "@/lib/constants";
import { IdCard, Phone, Mail, MapPin, Hash, CalendarClock, Award } from "lucide-react";

function Field({ icon: Icon, label, value, mono }) {
  return (
    <div className="flex items-start gap-3">
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100">
        <Icon className="h-4 w-4 text-slate-500" />
      </div>
      <div>
        <p className="text-xs font-medium uppercase tracking-wide text-slate-400">{label}</p>
        <p className={`text-sm font-semibold text-slate-900 ${mono ? "font-mono-code" : ""}`}>{value || "—"}</p>
      </div>
    </div>
  );
}

export default function GuardiaScheda({ g, actions }) {
  return (
    <div className="gz-fade-up space-y-6">
      <Card className="overflow-hidden border-slate-200 shadow-sm">
        <div className="flex items-center gap-4 bg-[#14382C] p-6 text-white">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#166534] font-heading text-xl font-extrabold">
            {(g.nome?.[0] || "") + (g.cognome?.[0] || "")}
          </div>
          <div className="flex-1">
            <h1 className="font-heading text-2xl font-extrabold">{g.cognome} {g.nome}</h1>
            <p className="font-mono-code text-sm text-emerald-100/80">{g.codice_fiscale}</p>
          </div>
          <StatoGuardiaBadge stato={g.stato} testid="guard-detail-stato" />
        </div>
        <CardContent className="grid gap-5 p-6 sm:grid-cols-2">
          <Field icon={Hash} label="Matricola" value={g.matricola} />
          <Field icon={Award} label="Ruolo / Grado" value={g.ruolo_grado} />
          <Field icon={IdCard} label="Numero tessera" value={g.numero_tessera} />
          <Field icon={MapPin} label="Distaccamento operativo" value={g.distaccamento} />
          <Field icon={Phone} label="Telefono" value={g.telefono} />
          <Field icon={Mail} label="Email" value={g.email} />
          {g.numero_decreto && <Field icon={Hash} label="Numero decreto" value={g.numero_decreto} mono />}
        </CardContent>
      </Card>

      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-6">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-slate-900">
              <CalendarClock className="h-5 w-5 text-[#D97706]" /> Scadenze
            </h2>
            {actions}
          </div>
          <div className="grid gap-4 sm:grid-cols-3">
            <div className="rounded-lg border border-slate-200 p-4">
              <p className="text-xs font-medium uppercase tracking-wide text-slate-400">Scadenza nomina</p>
              <p className="mt-1 font-semibold text-slate-900">{fmtDate(g.scadenza_nomina)}</p>
              <div className="mt-2"><ScadenzaBadge giorni={g.giorni_nomina} /></div>
            </div>
            <div className="rounded-lg border border-slate-200 p-4">
              <p className="text-xs font-medium uppercase tracking-wide text-slate-400">Scadenza tesserino</p>
              <p className="mt-1 font-semibold text-slate-900">{fmtDate(g.scadenza_tesserino)}</p>
              <div className="mt-2"><ScadenzaBadge giorni={g.giorni_tesserino} /></div>
            </div>
            <div className="rounded-lg border border-slate-200 p-4" data-testid="decreto-box">
              <p className="text-xs font-medium uppercase tracking-wide text-slate-400">Scadenza decreto (2 anni)</p>
              <p className="mt-1 font-semibold text-slate-900">{fmtDate(g.scadenza_decreto)}</p>
              <p className="text-xs text-slate-400">
                {g.data_rilascio_decreto ? `Rilascio: ${fmtDate(g.data_rilascio_decreto)}` : "Data di rilascio non impostata"}
              </p>
              <div className="mt-2"><ScadenzaBadge giorni={g.giorni_decreto} /></div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
